module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-left-panel-2-92f90dd1183a7b577fdd70cc50796b1e.svg";